import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=6ccb7594&scoped=true"
import script from "./flow.vue?vue&type=script&lang=js"
export * from "./flow.vue?vue&type=script&lang=js"
import style0 from "./flow.vue?vue&type=style&index=0&id=6ccb7594&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb7594",
  null
  
)

export default component.exports